import { computed } from 'vue';

import { hasPermission } from '@/shared/helpers/permissions.helpers';

export const canViewAllBookings = computed(() => hasPermission('sales', 'bookingsViewAll'));
export const canEditAllBookings = computed(() => hasPermission('sales', 'bookingsEditAll'));
export const canEditOwnBookings = computed(() => hasPermission('sales', 'bookingsEditOwn'));
export const canViewBookingContactInfo = computed(() => hasPermission('crm'));
